var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2052 45.2945C36.5994 46.6207 36.5994 48.7969 35.2052 50.1231C33.8791 51.4493 31.7028 51.4493 30.3766 50.1231C23.7458 43.4923 23.7458 32.7129 30.3766 26.082L42.4142 14.0444C49.045 7.41357 59.8244 7.41357 66.4553 14.0444C73.0861 20.6753 73.0861 31.4547 66.4553 38.0856L61.3886 43.1522C61.4226 40.3638 60.9806 37.5755 60.0285 34.9231L61.6267 33.2909C65.6392 29.3124 65.6392 22.8516 61.6267 18.8731C57.6481 14.8605 51.1873 14.8605 47.2088 18.8731L35.2052 30.8766C31.1927 34.8551 31.1927 41.316 35.2052 45.2945ZM44.7945 30.8766C46.1207 29.5504 48.2969 29.5504 49.6231 30.8766C56.254 37.5075 56.254 48.2869 49.6231 54.9177L37.5855 66.9553C30.9547 73.5862 20.1753 73.5862 13.5444 66.9553C6.91357 60.3244 6.91357 49.545 13.5444 42.9142L18.6111 37.8475C18.5771 40.6359 19.0191 43.4242 19.9713 46.1106L18.3731 47.7088C14.3605 51.6873 14.3605 58.1482 18.3731 62.1267C22.3516 66.1392 28.8124 66.1392 32.7909 62.1267L44.7945 50.1231C48.807 46.1446 48.807 39.6838 44.7945 35.7052C43.4003 34.3791 43.4003 32.2028 44.7945 30.8766Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink28);
export default __webpack_public_path__ + "static/media/link_28.18e95519.svg";
export { ForwardRef as ReactComponent };